import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../common/ui/Logo';

export const AuthFooter = () => {
    return (
        <footer className="simple-footer py-3">
            <div className="text-muted text-center">
                <Link to="">
                    <Logo className="d-inline-block" size="2x" color="muted" />
                </Link>
                React Gift Shop © {new Date().getFullYear()}
            </div>
        </footer>
    );
};
